import type { AddTabToWorkspaceOptions } from 'epic/workspace/common/tabs/tabsEpics';
import { openTabInWorkspaceEpic } from 'epic/workspace/common/tabs/tabsEpics';
import type { SecondaryMarketOpenTabFromTradeAllocationRequested } from 'state/secondaryMarket/openTabFromTradeAllocation.actions';
import { secondaryMarketTabCreatedFromTradeAllocationThunk } from 'state/secondaryMarket/secondaryMarket.thunks';
import type { EpicWithThunk } from 'state/state.common';
import type { WorkspacePersistedTabsApplied } from 'state/workspaces/workspace.actions';

export function secondaryWorkspaceOpenTabFromTradeAllocationEpic(): EpicWithThunk {
  const opt: AddTabToWorkspaceOptions<
    SecondaryMarketOpenTabFromTradeAllocationRequested,
    WorkspacePersistedTabsApplied
  > = {
    workspaceReadyTriggers: ['WORKSPACE_PERSISTED_TABS_APPLIED'],
    targetWorkspace: 'secondaryMarketQuotes',
    triggers: ['SECONDARY_MARKET_OPEN_TAB_FROM_TRADE_ALLOCATION_REQUESTED'],
    navigateRoute: { path: '/secondary-market-quotes-workspace' },
    onReady: ({ formType, bcsKey, isin }) => secondaryMarketTabCreatedFromTradeAllocationThunk(formType, bcsKey, isin),
  };
  return openTabInWorkspaceEpic(opt);
}
